import { type FC, type ReactNode } from "react";
import { useSelector } from "react-redux";
import { selectIsInFlight, selectSearchQuery } from "~/features/search/redux/searchSelectors";
import { PackageRestrictionContext } from "~/features/PackageRestriction/PackageRestrictionContext";
import { useCalculateRestrictedCode } from "~/features/PackageRestriction/hooks/useCalculateRestrictedCode";

interface Props {
  productCode: string;
  children?: ReactNode;
}
export const SRPPackageRestrictionContext: FC<Props> = ({ productCode, children }) => {
  const query = useSelector(selectSearchQuery);
  const isInFlight = useSelector(selectIsInFlight);
  const restrictedCode = useCalculateRestrictedCode(isInFlight ? "" : query, productCode);

  return <PackageRestrictionContext value={restrictedCode}>{children}</PackageRestrictionContext>;
};
